import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import styled from 'styled-components';
import MessageModal from '../../utils/components/Modals/MessageModal/MessageModal'

// icons
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

// IMPORT FUNCTIONS AND SERVICES
import getUrl from  "../../utils/functions/getUrl";
import PostDataComplex from '../../services/PostDataComplex';
import PostData from '../../services/PostData';
import UploadAndDisplayImage from '../Dashboard/components/UploadAndDisplayImage';
import saveImagesToServer from '../../utils/functions/uploadImages';
import delay from '../../utils/functions/delay';
import addToFolder from '../../utils/functions/addToFolder';
import removeImageFromAlbum from '../../utils/functions/removeImageFromAlbum';

// IMPORT LOCAL FUNCTIONS
import renameAlbum from './functions/renameAlbum';

// IMPORT COMPONENTS 
import Modal from './components/Modal/Modal';

// IMPORT COMMON COMPONENTS
import PictureHolder from '../../utils/components/PictureHolder/PictureHolder';

// IMPORT DATA FOR LOCAL USE
import imageAssocData from './imageAssocData';

// 
// manage selected album - albumId in sessionStorage
// 
const Album = ( { handleImageModalExpand } ) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  // get album Info from sessionStorage
  const [albumId, setAlbumId] = useState((JSON.parse(sessionStorage.albumInfo)).currentAlbumId);
  const [albumName, setAlbumName] = useState((JSON.parse(sessionStorage.albumInfo)).currentAlbumName);

  const [images, setImages] = useState(null);
  const [toggleRenameAlbumModal, setToggleRenameAlbumModal] = useState(false);
  const [renameAlbumMessage, setRenameAlbumMessage] = useState(null);
  const [renameAlbumErrorMessage, setRenameErrorAlbumMessage] = useState(null);


  const [imgs] = useState(BASE_URL + '/uploaded/imgs/');
  const [mini] = useState(BASE_URL + '/uploaded/mini/');

  const [toggleMessageModal, setToggleMessageModal] = useState()
  const [messageTitle, setMessageTitle] = useState()
  const [message, setMessage] = useState()
  const [errorMessage, setErrorMessage] = useState()

  const [newImageAsoc, setNewImageAssoc] = useState(false)


  // 
  // get album images
  // 
  useEffect(()=>{
    getAlbumImages(albumId);
    setNewImageAssoc(false);
  },[albumId, newImageAsoc]);


  // 
  // 
  // 
  const handleRenameAlbum = (newAlbumName, albumId) => {
    console.log(`handleRenameAlbum()`);

    console.log(`newAlbumName: ${newAlbumName}`);
    console.log(`albumId: ${albumId}`);

    function newNameAlbum(result) {
      console.log(`newNameAlbum()`);

      console.log(`result:->`);
      console.log(result);

      if(result.renamed) {
        setAlbumName(result.albumName);
        setRenameAlbumMessage(null);
        setToggleRenameAlbumModal(false);
      } else {
        setRenameErrorAlbumMessage(result.error);
      }
    }

    renameAlbum(newAlbumName, albumId, newNameAlbum);
    
  }


  // 
  // remove image from folder
  // 
  const handleRemove = (e, img_id, idx) => {
    console.log(`handleRemove()`);

    console.log(`e:->`);
    console.log(e);
    console.log(`idx: ${idx}`);
    console.log(`img_id: ${img_id}`);
    console.log(`albumId: ${albumId}`);

    // const aImages = images.slice(0, idx).concat(images.slice(idx + 1, images.length));
    // setImages(aImages);
 
    // // moved to removeImageFromAlbum()
    // const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    // console.log(`user: ${user}`);
    // const token = (JSON.parse(sessionStorage.userData)).user.token;
    // console.log(`token: ${token}`);

    // const data = {
    //   user: user,
    //   token: token,
    //   image_id: img_id,
    //   album_id: albumId,
    // }

    // PostDataComplex('albums_manager', 'POST', 'removeFromFolder', data)
    //   .then((response) => {
    //     console.log('response.data:->');
    //     console.log(response.data);

    //     const removeFromFolder = response.data.feedBack.removeFromFolder.removeFromFolderResult;

    //     if(removeFromFolder.imageRemovedFromFolder) {
    //       console.log('images album association removed succesfully!!!');
          
    //       // setImages([...getAlbumImages].reverse());
    //       const aImages = images.slice(0, idx).concat(images.slice(idx + 1, images.length));
    //       setImages(aImages);
          
          
    //     } else {
    //       console.log(removeFromFolder.error);
    //     }
    //   }
    // )

    const res = removeImageFromAlbum(img_id, idx, albumId)

    const aImages = res > -1 && images.slice(0, idx).concat(images.slice(idx + 1, images.length));
    setImages(aImages);

  }

  // 
  // 
  // 
  const handleExpand = (image) => {

    console.log('image:->');
    console.log(image);

    const imageData= {
      id: image.id,
      img_name: image.img_name.replace("_mini", ""),
      img_mini_name: image.img_name
    }

    console.log('imageData:->');
    console.log(imageData);

    handleImageModalExpand(imageData);

  }

  // 
  // 
  // 
  const handleSave = () => {
    console.log(`handleSave()`);
  }


  // 
  // getAlbumImages()
  // 
  const getAlbumImages = (albumId) => {
    console.log('getAlbumImages()');

    console.log(`albumId: ${albumId}`);

    const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);
    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);

    const data = {
      user: user,
      token: token,
      album_id: albumId,
    }

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);
    
    if( localHost || network) {
      console.log('LOCALE!!!')

      // const getAlbumImages = imageAssocData.map((i, iIndex) => ({
      //   ...i, img_mini_name: i.img_name  // <== add mg_mini_name to the object
      // }));

      console.log(`imageAssocData[0].album_id: ${imageAssocData[0].album_id}`)
      const getAlbumImages = imageAssocData.map((i, iIndex) => i.album_id === albumId ? {...i, img_mini_name: i.img_name // <== add mg_mini_name to the object
      } : ''
      )

      if(getAlbumImages) {
        console.log('getAlbumImages:->');
        console.log(getAlbumImages);
        console.log('getAlbumImages uploaded succesfully!!!');

        setImages([...getAlbumImages].reverse());

      } else {
        console.log('Images upload error!!!');
      }

    } else {


      // PostData('POST', 'getAlbumImages', data)
      PostDataComplex('albums_manager', 'POST', 'getAlbumImages', data)
        .then((response) => {
          console.log('response.data:->');
          console.log(response.data);

          const getAlbumImages = response.data.feedBack.getAlbumImages.getAlbumImagesResult.imagesassoc.map((i, iIndex) => ({
            ...i, img_mini_name: i.img_name // <== add mg_mini_name to the object
          }));;
              

          if(getAlbumImages) {
            console.log('album images uploaded succesfully!!!');
            
            setImages([...getAlbumImages].reverse());
            
            
          } else {
            console.log('error uploading album images !!!');
          }
        }
      )

    }
    

  }

  // 
  // uploading images to server
  //  

  const handleSetImage = async (images) => {
    console.log(`handleSetImage()`);

    setToggleMessageModal(true);
    setMessage(`Please wait while uploading image ...`);
    
    console.log(`images.length: ${images.length}`)
    
    let res
    for(let imageNumber=0; imageNumber < images.length; imageNumber++) {

      setMessage(``);
      setErrorMessage(``);
      setMessage(`Please wait while uploading image ... ${imageNumber+1}/${images.length}`);
      
      // upload image to server
      res = await saveImagesToServer(images[imageNumber]);
      res[1] && setMessage(res[1]);
      res[2] && setErrorMessage(res[2]);

      const image_id = res[3]
      // const imageName = 'piramid-building.jpg'
      const imageMiniName = images[imageNumber].name.split(".")[0] + '_mini.' + images[imageNumber].name.split(".")[1]
      
      // add image to this folder
      console.log(`image_id]: ${image_id}`)
      console.log(`imageMiniName]: ${imageMiniName}`)
      console.log(`albumId: ${albumId}`)
      console.log(`albumName: ${albumName}`)

      const token = (JSON.parse(sessionStorage.userData)).user.token;
      console.log(`token: ${token}`);
      const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
      console.log(`user: ${user}`);

      const resAlbum_id = await addToFolder(image_id, imageMiniName, albumName, albumId, user)

      setNewImageAssoc(true)    // <=======


      await delay(500)
    }

    setToggleMessageModal(false);

  }

  
  return (
    <Wrapper id="dashboard--wrapper">
      <Container id="dashboard--container">

        <Header id="dashboard--header">

          
          {
            albumName 
          ? 
            <>
              <span className="strong"><Link to={BASE_URL + "/dashboard"}><ExitToAppIcon/></Link></span>
              <span className='title-container'><span className="strong">{albumName}</span><span className='icon-container' onClick={setToggleRenameAlbumModal} title='rename album'><DriveFileRenameOutlineIcon sx={{ fontSize: 15 }}/></span></span>
            </>
          :
            <span className="strong">Album name not yet set!!!</span>  
          }
          
          {/* <div className='albums'>
            {!albums 
              ? 
                <>
                  <span className="minor">It looks like you haven't created any picture album yet.</span>
                  <span className='createAbum' onClick={()=>handleCreateAlbum('new album')}>new album</span>
                </>
              :
                albums.map((album, albumIndex) => 
                  <div className='album' onClick={()=>handleOpenAlbum(album.id)} key={`${albumIndex}-albums`}>
                    <div className='icon'><PermMediaIcon sx={{ fontSize: 180 }} /></div>
                    <div className='text'>{album.album_name} - {album.albumLength}</div>
                  </div>
                )
            }
          </div> */}

          
          
          
          {!images && <span className="minor">It looks like you haven't added any picture in this PictureViewer album yet.</span>}
          
        </Header>

        {/* <Content className="dashboard--Content">
          <span>Or do you want to start by uploading some terrific picture?</span>
        </Content> */}

        

        <PictureContainer className="dashboard--Content">
          
          {/* { image && <div className="image-container"><img src={URL.createObjectURL(image)} alt="the-liberty-homes.jpg" title="the liberty homes" /></div> } */}
          


          {/* <div className="image-container"><UploadAndDisplayImage image={handleSetImage}/></div> */}


          <div className="image-wrapper">
            <UploadAndDisplayImage image={handleSetImage} />
          </div>


          { images && images.map((image, imageIndex) =>
           
              <div className="image-container">
                
                <div key="imageIndex">

                  <PictureHolder mini={mini} image={image} />

                  <div className="loaded-image">
                    <div className='loaded-image-top'>
                      <div className='remove' onClick={(e)=>handleRemove(e, image.img_id, imageIndex)} title='remove this image from album'>
                        <HighlightOffIcon/>
                      </div>
                      {/* NOTE: adapt following procedure 
                        to add an image from this folder 
                        to another folder */}
                      {/* <div className='addToFolder' >
                        <div className='dropbtn'><DriveFileMoveIcon/></div>
                        <div className="dropdown-content">
                          {
                            albums && albums.map((album, albumIndex) =>
                              <span 
                                key={`${albumIndex}-album`} 
                                onClick={
                                  (e)=>handleAddToFolder(
                                    e, 
                                    image.id, 
                                    image.img_mini_name,
                                    album.album_name, 
                                    album.id,
                                    album.album_usr
                                  )
                                }
                              >{album.album_name}</span>
                            )
                          }
                        </div>
                      </div> */}
                    </div>
                    <div className='expand' onClick={()=>handleExpand(image)}>
                      <AspectRatioIcon sx={{ fontSize: 60 }}/>
                    </div>
                    <div className='save' onClick={handleSave}>
                      <SaveAltIcon/>
                    </div>
                  </div>
                </div> 

              </div>
              
            )
          } 

        </PictureContainer>

        
        {/* create new album */}
        {toggleRenameAlbumModal && <Modal currentAlbumName={albumName} albumId={albumId} closeModal={setToggleRenameAlbumModal} handleRenameAlbum={handleRenameAlbum} renameAlbumMessage={renameAlbumMessage}  renameAlbumErrorMessage={renameAlbumErrorMessage} />}

        {/* MessageModal */}
        {toggleMessageModal && <MessageModal closeModal={setToggleMessageModal} title={messageTitle} message={message} errorMessage={errorMessage}/>}

      </Container>
    </Wrapper>
    
  )
}

export default Album;

const Wrapper = styled.div `
  width: 100%;
  /* height: 90vh; */
  min-height: 90vh;
  color: #d1d1d1;
  background-color: transparent;
  font-size:2rem;
  /* padding: 10px 30px; */

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
`;

const Container = styled.div `
  min-width: 80vw;
  max-width: 90%;
  border: 1px solid orange;
  margin-top: 60px;
  max-width: 100%;
  padding: 30px 50px;
  background-color: rgba(0,0,0,0.4);

  .image-wrapper {
    position: relative;

    width: 200px;
    height: 130px;
    margin: 20px 10px;
    border: 1px solid orange;
    overflow: hidden;
    background-color: rgba(0,0,0,0);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* div.image-container {
      max-height: 130px;
      aspect-ratio: 4/3;

      img.loaded-image {
        position: relative;
        height: 135px;
        image-orientation: from-image; 
        // image-orientation: none; 
      }
    }  */
  }
`;

const Header = styled.div `
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  span.title-container {
    display: flex;
    align-items: flex-start;
  }

  span.strong {
    font-size: 1.8rem;
    font-weight: 600;
    text-align: center;
  }  
  
  span.icon-container {
    margin-top: -15px;;
  }

  span.minor {
    margin-top: 30px;
    font-size: 1.2rem;
    font-weight: 400;
    text-align: center;
  }

  span.createAbum {
    cursor: pointer;
  }

  div.albums {
    display: flex;
    flex-direction: row;
    
    flex-wrap: wrap;

    margin-top: 3rem;
    
    div.album {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 200px;
      height: 160px;
      border: 1px solid orange;
      font-size: 1.4rem;
      margin-right: 2rem;
      text-decoration: underline;
      cursor: pointer;
      position: relative;

      .icon {
        position: absolute;
      }
      .text {
        position: absolute;

        color: orange;
        font-weight: 700;
        background-color: rgba(0,0,0,.6);
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;

const Content = styled.div `

  display: flex;
  /* flex-direction: row; */
  justify-content: center;
  align-items: center;

  margin-top: 2.8rem;

  .image-container {
    width: 200px;
    height: 130px;
    margin: 20px 10px;
    border: 1px solid orange;
    overflow: hidden;

    &:last-child {
      margin-right: 0;
    }

    img {
      width: 100%;
    }
  }

  span {
    font-size: 1.4rem;
    font-weight: 700;
  }

`;

const PictureContainer = styled.div `

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  margin-top: 2.8rem;

  .image-container {
    position: relative;

    width: 200px;
    height: 130px;
    margin: 20px 10px;
    border: 1px solid orange;
    overflow: hidden;
    /* background-color: #d1d1d1; */

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    div.image-container {
      /* width: 200px; */
      max-height: 130px;
      aspect-ratio: 4/3;

      img.loaded-image {
        position: relative;
        /* top: 0;
        left: 0; */
        /* width: 100%; */
        height: 135px;
        image-orientation: from-image; 
        /* image-orientation: none;  */
      }
    }
    div.loaded-image {
      position: absolute;
      top: 0;
      left: 0;
      /* display: none; */
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0);
      color: transparent;
      transition: all .7s ease-in-out;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      /* align-items: center; */

      .remove {
        text-align: right;
        padding: 0;
        margin: 0;
        line-height: .8rem;
      }
      .addToFolder {
        /* text-align: left; */
        padding: 0;
        margin: 0;
        line-height: .8rem;

        /* Dropdown Content (Hidden by Default) */
        .dropdown-content {
          display: none;
          position: absolute;
          background-color: #f1f1f1;
          min-width: 160px;
          box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
          z-index: 1;
          overflow-y: auto;
          margin-left: 10px;
          padding: 2px 0px;
        }

        /* Spans inside the dropdown */
        .dropdown-content span {
          color: black;
          padding: 2px 6px;
          text-decoration: none;
          display: block;
          font-size: .8rem;
        }

        /* Change color of dropdown links on hover */
        .dropdown-content span:hover {background-color: #ddd;}

        /* Show the dropdown menu on hover */
        &:hover .dropdown-content {display: block;}

        /* Change the background color of the dropdown button when the dropdown content is shown */
        /* &:hover .dropbtn {background-color: #3e8e41;} */
      }

      .expand {
        text-align: center;
        padding: 0;
        margin: 0;
      }
      .save {
        text-align: right;
        padding: 0;
        margin: 0;
        line-height: .8rem;
      }

      &:hover {
        background-color: rgba(0,0,0,0.4);
        color: #d1d1d1;
      }

      div {
        font-size: 1.4rem;
        /* text-align: center; */
        cursor: pointer;
        /* margin-bottom: 10px; */
      }
    }


    div.cross {
      color: red;
      margin: 0;
      padding: 0;
      font-size: 6rem;
      font-weight: 100;
    }

    &:last-child {
      margin-right: 0;
    }

    img {
      width: 100%;
    }
  }

  span {
    font-size: 1.4rem;
    font-weight: 700;
  }

`;

const Button = styled.button `
  color: #fff;
  border: 1px solid #1b1b1b;
  background-color: #029F85;
  border-radius: 5px;;
  font-size: 1rem;
  padding: 1rem .8rem;
  margin-top: .4rem;
  width: 200px;

  cursor: pointer;
`;


const Features = styled.div `
  width: 100%;
  font-size: 1.4rem;
  font-weight: 700;

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items: center; */

  p {
    margin-top: 20px;
    font-size: 1rem;
    font-weight: 100;

    display: flex;
    flex-direction: column;

    .icon-container {
      margin-right: 30px;

      display: flex;
      gap: 10px;

      div {
        font-weight: 600;
        font-size: 1.2rem;
      }
    }

    div {
      font-weight: 100;

    }
  }

`;
